import { useTranslation } from 'react-i18next'
import { KibModal } from '@chewy/kib-overlays-react'

import { PaymentControls } from '~/components/dashboard/invoices/payment/add-payment-dialog-v2/components/PaymentControls'

import { usePaymentRequestDialog } from '../context/PaymentRequestDialogProvider'
import { PaymentRequestScreen } from '../screens/PaymentRequestScreen'

import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css'
import '@chewy/kib-transition-styles/dist/kib-transition.css'
import styles from './PaymentRequestDialogV2.module.scss'

interface PaymentRequestDialogV2Props {
  isOpen: boolean
  onClose: () => void
}

export const PaymentRequestDialogV2 = ({
  isOpen,
  onClose,
}: PaymentRequestDialogV2Props) => {
  const { actions } = usePaymentRequestDialog()
  const { t } = useTranslation('Common')

  const sendPaymentControls = () => (
    <PaymentControls
      align="left"
      disabled={false}
      emphasis="primary"
      isLoading={false}
      primaryAction={actions.sendPayment}
      primaryText={t('Common:SEND_ACTION')}
    />
  )

  return (
    <KibModal
      className={styles.paymentRequestDialogV2Container}
      controls={sendPaymentControls}
      open={isOpen}
      title={t('Common:REQUEST_PAYMENT')}
      onClose={onClose}
    >
      <PaymentRequestScreen />
    </KibModal>
  )
}
